import { observable, action, computed } from "mobx";
import { filesizeHumanize } from "../../../../utils";

const translator: any = (window as any).$.translator,
  locales: any = {
    filestypes: {
      all: translator.translate("Все файлы"),
      image: translator.translate("Картинки"),
      audio: translator.translate("Аудио"),
      video: translator.translate("Видео"),
      doc: translator.translate("Прочее"),
    },
  };

export default class FSCourseStore {
  rootStore: any;
  constructor(RootStore: any) {
    this.rootStore = RootStore;

    this.filestorageSpaceTotal = 0;
    this.filestorageSpaceUsed = 0;
    this.isHaveFilesInCourse = false;
    this.isHaveFilesInAll = false;

    this.filesSectionInitial = `notuse`;
    this.filesSection = `notuse`;
    this.filesSectionTab = `all`;

    this.isFileslistExpanded = true;

    this.filterFilesType = `all`;
    this.filterSortBy = `added`;
    this.filterSortOrder = `desc`;
    this.filterSearch = ``;

    this.isFileUploadInProgress = false;
    this.fileUploadCurrentProgress = 0;
    this.fileUploadMessage = "";
    this.fileUploadCurrentProccess = 0;
  }

  filesTypesOptionsList = [
    { value: "all", label: locales.filestypes.all },
    { value: "image", label: locales.filestypes.image },
    { value: "audio", label: locales.filestypes.audio },
    { value: "video", label: locales.filestypes.video },
    { value: "doc", label: locales.filestypes.doc },
  ];

  @observable filestorageSpaceTotal: number;
  @observable filestorageSpaceUsed: number;

  @observable cancelToken: any;
  @action setCancelToken = (token: any) => {
    this.cancelToken = token;
  };

  @observable isHaveFilesInCourse: boolean;
  @observable isHaveFilesInAll: boolean;

  @observable filesSectionInitial: string;
  @observable filesSection: string;
  @observable filesSectionTab: string;

  @observable isFileslistExpanded: boolean;

  @observable filterFilesType: string;
  @observable filterSortBy: string;
  @observable filterSortOrder: string;
  @observable filterSearch: string;

  @observable isFileUploadInProgress: boolean;
  @observable fileUploadCurrentProgress: number;
  @observable fileUploadMessage: string;
  @observable fileUploadCurrentProccess: number;

  @computed get fsSpaceTotal() {
    return filesizeHumanize(this.filestorageSpaceTotal, true);
  }

  @computed get fsSpaceUsed() {
    return filesizeHumanize(this.filestorageSpaceUsed);
  }

  @computed get fsSpacePercentage() {
    return Math.min(
      100,
      (this.filestorageSpaceUsed / this.filestorageSpaceTotal) * 100
    );
  }

  @computed get isTabsVisible() {
    if (this.filesSection === "notuse" || this.filesSection === "lessons") {
      return this.rootStore.fsStore.isWidget;
    }
    return true;
  }

  @computed get isFileslistGrouped() {
    return (
      this.filesSection === "lessons" ||
      ((this.filesSection === "homeworks" || this.filesSection === "chats") &&
        this.filesSectionTab !== "all")
    );
  }

  @computed get isFileslistCarded() {
    return this.filterFilesType === "video" || this.filterFilesType === "image" || this.filterFilesType === "transcription";
  }

  @computed get getFileslistLimit() {
    return this.isFileslistCarded ? 24 : 50;
  }

  @computed get getFileslistAPIUrl() {
    let url = `/${this.rootStore.fsStore.module}/files/${this.filesSection}?`;
    url += this.filesSectionTab ? `tab=${this.filesSectionTab}&` : ``;
    url += `course_id=${this.rootStore.fsStore.course_id}&type=${this.filterFilesType}&sort=${this.filterSortBy}&sort_type=${this.filterSortOrder}&search=${this.filterSearch}`;
    return url;
  }

  @computed get getFilterKey() {
    return (
      this.filterFilesType +
      this.filterSortBy +
      this.filterSortOrder +
      this.filterSearch +
      this.filesSection +
      this.filesSectionTab
    );
  }

  @computed get isSearchNotEmpty() {
    return this.filterFilesType !== "all" || this.filterSearch !== "";
  }

  @action
  onToggleGroups = () => {
    const groupsListElements = document.querySelectorAll(
      ".filestorage-listhead"
    );
    if (this.isFileslistExpanded) {
      [].forEach.call(groupsListElements, (el: any) => {
        el.classList.remove("active");
      });
    } else {
      [].forEach.call(groupsListElements, (el: any) => {
        el.classList.add("active");
      });
    }
    this.isFileslistExpanded = !this.isFileslistExpanded;
  };

  @action
  setFilestorageSpaceStatus = (used: number, total?: number) => {
    if (total) {
      this.filestorageSpaceTotal = total;
    }
    this.filestorageSpaceUsed = used;
    this.isHaveFilesInAll = true;
    this.isHaveFilesInCourse = true;
  };

  @action
  setFilesSectionAndTab = (section: string, tab?: string) => {
    this.filesSection = section;
    this.filesSectionTab = tab;
    let url =
      "/panel/files/courses?course_id=" + this.rootStore.fsStore.course_id;
    url += section ? "&section=" + section : "";
    url += tab ? "&sectionTab=" + tab : "";

    if (!this.rootStore.fsStore.isWidget) {
      (window as any).history.pushState("", "", url);
    }
  };

  @action
  setFilterParams = (params: {
    filestype?: string;
    sortby?: string;
    sortorder?: string;
    search?: string;
  }) => {
    if (params.filestype) {
      this.filterFilesType = params.filestype;
    }
    if (params.sortby) {
      this.filterSortBy = params.sortby;
    }
    if (params.sortorder) {
      this.filterSortOrder = params.sortorder;
    }
    if (typeof params.search === "string") {
      this.filterSearch = params.search;
    }
  };

  @action
  toggleFileUploadInProgress = (action: boolean) => {
    this.isFileUploadInProgress = action;
  };

  @action
  setFileUploadCurrentProgress = (value: number) => {
    this.fileUploadCurrentProgress = value;
  };

  @action
  setFileUploadMessage = (message: string) => {
    this.fileUploadMessage = message;
  };

  @action
  setFileUploadCurrentProccess = (value: number) => {
    this.fileUploadCurrentProccess = value;
  };

  @action
  resetFilterParams = () => {
    this.filterFilesType = "all";
    this.filterSortBy = "added";
    this.filterSortOrder = "desc";
    this.filterSearch = "";
    this.filesSection = "notuse";
    this.filesSectionTab = "all";
    this.rootStore.fsStore.salt = new Date().getTime();

    if (!this.rootStore.fsStore.isWidget) {
      (window as any).history.pushState(
        "",
        "",
        "/panel/files/courses?course_id=" + this.rootStore.fsStore.course_id
      );
    }
  };

  @action
  resetFilterParamsSoft = () => {
    this.filterFilesType = "all";
    this.filterSortBy = "added";
    this.filterSortOrder = "desc";
    this.filterSearch = "";
  };

  @action
  onUpload = (files: any, attachOnUploadDone: boolean = true) => {
    const newFiles: Array<any> = [];
    files.map((item: any) => {
      const date = new Date();
      const fileDate =
        ("0" + date.getDate()).slice(-2) +
        "." +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "." +
        date
          .getFullYear()
          .toString()
          .slice(-2);
      newFiles.push({
        attachedCode: item.code,
        category: item.category,
        date: fileDate,
        downloadUrl: item.src,
        id: item.id,
        name: item.file,
        size: item.size,
        srcUrl: item.src,
      });
      this.setFilestorageSpaceStatus(parseInt(item.fileStorageSizeUsed));
    });
    if (
      this.rootStore.fsStore.isWidget &&
      !!this.rootStore.fsStore.onAttach &&
      attachOnUploadDone
    ) {
      this.rootStore.fsStore.onAttachAll(newFiles);
    } else {
      this.resetFilterParams();
    }
  };
}
